import React, { useState, useEffect, useRef } from "react";
import Carousel from "react-multi-carousel";
import { responsive } from "../../data";
import config from "../../config";
import { FaDownload, FaPauseCircle, FaPlayCircle } from "react-icons/fa";
import { useLanguage } from "../../Context";

export default function Audio() {
  const [items, setItems] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { language } = useLanguage();

  const audioRefs = useRef([]);
  const [audioStates, setAudioStates] = useState([]);

  const [currentAudioIndex, setCurrentAudioIndex] = useState(-1); // Track the index of the currently playing audio
  const [isSeeking, setIsSeeking] = useState(false); // Track whether the user is actively seeking

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=7&categoryid=2&subcategory=0&limitCount=10&lang=${language}`
    )
      .then((response) => response.json())
      .then((items) => {
        setItems(items);
        setIsLoading(false);
        setAudioStates(items.map(() => ({ currentTime: 0, duration: 0 })));
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, [language]);

  const playAudio = (index) => {
    if (audioRefs.current[index] && audioRefs.current[index].play) {
      audioRefs.current[index].play();
      setCurrentAudioIndex(index);
    }
  };

  const pauseAudio = (index) => {
    if (audioRefs.current[index] && audioRefs.current[index].pause) {
      audioRefs.current[index].pause();
    }
  };

  const toggleAudio = (index) => {
    if (currentAudioIndex === index) {
      if (audioRefs.current[index].paused) {
        playAudio(index);
      } else {
        pauseAudio(index);
      }
    } else {
      if (currentAudioIndex !== -1) {
        pauseAudio(currentAudioIndex);
      }
      playAudio(index);
    }
  };

  const handleLoadedMetadata = (event, index) => {
    const newDuration = event.target.duration;
    setAudioStates((prevStates) =>
      prevStates.map((state, i) =>
        i === index ? { ...state, duration: newDuration } : state
      )
    );
  };

  useEffect(() => {
    const updateSeekBars = () => {
      if (!isSeeking && currentAudioIndex !== -1) {
        setAudioStates((prevStates) =>
          prevStates.map((state, index) =>
            index === currentAudioIndex
              ? { ...state, currentTime: audioRefs.current[index].currentTime }
              : state
          )
        );
      }
    };

    // Update the seek bar every 250 milliseconds while audio is playing
    const seekBarUpdateInterval = setInterval(updateSeekBars, 250);

    return () => {
      clearInterval(seekBarUpdateInterval); // Clean up the interval
    };
  }, [currentAudioIndex, isSeeking]);

  // Modify your handleSeekBarChange function to handle user seeking
  const handleSeekBarChange = (event, index) => {
    const newTime = parseFloat(event.target.value);
    setAudioStates((prevStates) =>
      prevStates.map((state, i) =>
        i === index ? { ...state, currentTime: newTime } : state
      )
    );

    if (audioRefs.current[index]) {
      audioRefs.current[index].currentTime = newTime;
    }
  };

  // Add event listeners to track user interaction with the seek bar
  const handleSeekBarMouseDown = () => {
    setIsSeeking(true);
  };

  const handleSeekBarMouseUp = (index) => {
    setIsSeeking(false);
    if (currentAudioIndex === index) {
      playAudio(index);
    }
  };

  if (isLoading) {
    return (
      <div className="max-container-width py-3">
        <ul
          className="nav nav-tabs column-gap-1 border-0 p-0 audio-tab"
          id="myTab"
          role="tablist"
        >
          <li className="nav-item me-auto" role="presentation">
            <button
              className="nav-link border-0 bg-body-secondary px-4 active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home-tab-pane"
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="true"
            >
              صوتی ها
            </button>
          </li>
          <li className="nav-item ms-auto" role="presentation">
            <button
              className="nav-link border-0 bg-body-secondary px-4"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile-tab-pane"
              type="button"
              role="tab"
              aria-controls="profile-tab-pane"
              aria-selected="false"
            >
              پادکست ها
            </button>
          </li>
        </ul>
        <div
          className="tab-content border-top border-3 bg-body-tertiary p-3"
          id="myTabContent"
        >
          <div
            className="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabIndex="0"
          ></div>
          <div className="bg-body-secondary p-3">
            <Carousel responsive={responsive} rtl>
              {[...Array(5)].map((_, index) => (
                <p key={index} className="placeholder-glow mx-2">
                  <span
                    className="placeholder card col-12"
                    style={{ height: "15rem" }}
                  />
                </p>
              ))}
            </Carousel>
          </div>
          <div
            className="tab-pane fade"
            id="profile-tab-pane"
            role="tabpanel"
            aria-labelledby="profile-tab"
            tabIndex="0"
          ></div>
        </div>
      </div>
    );
  }

  // error if data is not fetched
  if (error) {
    return (
      <div className="max-container-width pt-4 pb-3">
        <p className="alert alert-danger" role="alert" dir="ltr">
          Something went wrong: {error.message}
        </p>
      </div>
    );
  }

  return (
    <div className="bg-body">
      <div className="max-container-width py-5">
        <ul
          className="nav nav-tabs column-gap-1 border-0 p-0 audio-tab"
          id="myTab"
          role="tablist"
        >
          <li className="nav-item me-auto" role="presentation">
            <button
              className="nav-link border-0 bg-body-secondary px-4 active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home-tab-pane"
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="true"
            >
              صوتی ها
            </button>
          </li>
          <li className="nav-item ms-auto" role="presentation">
            <button
              className="nav-link border-0 bg-body-secondary px-4"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile-tab-pane"
              type="button"
              role="tab"
              aria-controls="profile-tab-pane"
              aria-selected="false"
            >
              پادکست ها
            </button>
          </li>
        </ul>
        <div
          className="tab-content border-top border-3 bg-body-tertiary p-3"
          id="myTabContent"
        >
          <div
            className="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabIndex="0"
          >
            <Carousel rtl responsive={responsive}>
              {items.map((audioData, index) => (
                <div
                  className="card mx-2 border-0"
                  key={index}
                  style={{ height: "100%" }}
                >
                  <audio
                    ref={(ref) => (audioRefs.current[index] = ref)}
                    src={audioData.audioUrl}
                    onLoadedMetadata={(event) =>
                      handleLoadedMetadata(event, index)
                    }
                  ></audio>
                  <img
                    src={audioData.ImageUrl}
                    className="card-img-top object-fit-cover"
                    alt="..."
                    style={{ height: "13rem" }}
                  />
                  <div className="card-body px-3 pb-2">
                    <p className="card-text primary-text-blue mb-1 text-truncate">
                      {audioData.Title}
                    </p>
                    <input
                      dir="ltr"
                      type="range"
                      className="custom-range"
                      min={0}
                      max={audioStates[index]?.duration || 0}
                      step={1}
                      value={audioStates[index]?.currentTime || 0}
                      onChange={(event) => handleSeekBarChange(event, index)}
                      onMouseDown={handleSeekBarMouseDown}
                      onMouseUp={() => handleSeekBarMouseUp(index)}
                    />
                  </div>
                  <a
                    href={audioData.audioUrl}
                    target={"_blank"}
                    rel={"noreferrer"}
                    style={{
                      position: "absolute",
                      bottom: "1.5em",
                      right: "1em",
                    }}
                    className="icon-links link-dark text-decoration-none"
                  >
                    <FaDownload style={{ width: "1.5em", height: "1.5em" }} />
                  </a>
                  <button
                    className="btn pb-3"
                    onClick={() => toggleAudio(index)}
                  >
                    {currentAudioIndex === index &&
                    !audioRefs.current[index].paused ? (
                      <FaPauseCircle style={{ width: "2em", height: "2em" }} />
                    ) : (
                      <FaPlayCircle style={{ width: "2em", height: "2em" }} />
                    )}
                  </button>
                </div>
              ))}
            </Carousel>
          </div>
          <div
            className="tab-pane fade"
            id="profile-tab-pane"
            role="tabpanel"
            aria-labelledby="profile-tab"
            tabIndex="0"
          >
            پادکست ها
          </div>
        </div>
      </div>
    </div>
  );
}
